import React from 'react'
import PropTypes from 'prop-types'

import { Image } from 'Components/UI/_Legacy'

import { Container, Content } from './styles'

function ImageHolder({ data }) {
  return (
    <Container>
      <Content>
        {/* LCP element of /blueprint — lazy-loading it cost 7 s of load
            delay on throttled mobile. */}
        <Image alt="" image={data} priority />
      </Content>
    </Container>
  )
}

ImageHolder.propTypes = {
  data: PropTypes.object,
}

export default ImageHolder
